import CONFIG from '../../config';
import API from './Api';
import axios from 'axios';

const url = function (type, ticket) {
    let goTo = CONFIG.SSO.server[type];
    if(!goTo && CONFIG.SSO[type]) {
        return CONFIG.SSO[type];
    } else if(!goTo) {
        return false;
    }
    
    let param = ticket ? "&format="+CONFIG.SSO.server.responseType+"&" + CONFIG.SSO.server.ticket + "=" + ticket : "";
    return CONFIG.SSO.url + goTo + "?service=" + CONFIG.SSO.service + param
}

const SSO = {
    goTo: function (type) {
        //if(!url(type)) return false;
        window.location.assign(url(type));
        return null;
    },
   
    getData: function (ticket) {
        return (auth) => {
            console.log(url('serviceValidate', ticket))
            return axios.get({
                    method: 'get',
                    url : url('serviceValidate', ticket),
                    responseType: CONFIG.SSO.server.responseType
                })
                .then((res) => {
                    console.log(res.data)
                    return API.post('/user', { type: 'sso', data: res.data })
                        .catch(() => console.log('erase me'))
                        .then(() => auth(true))
                        .then(() => SSO.url('redirect'))
                        .catch(() => auth(false))
                    ;
                });
            }
    },

    getTicket: function(string) {
        if(!string) return false;

        //let reg = new RegExp(/^\?ticket=(ST-.{32,256})$/g) //follow rule of CAS 3.0
        let reg = new RegExp(/^\?ticket=(.{20,256})$/g)
        return reg.exec( string )[1];
    },

    isConnected: function () {
        return API.getToken();
    }
}

export default SSO;


// WEBPACK FOOTER //
// ./src/helper/api/Sso.js